import { type ReactChild } from "#customTypes/globalTypes"

interface GridProps {
  children?: ReactChild
  rows?: number
  columns?: number
  gap?: number
  columnGap?: number
  rowGap?: number
}

const Grid = ({
  children,
  rows = 1,
  columns = 3,
  gap = 10, // Both vertical and horizontal
  columnGap,
  rowGap,
}: GridProps) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gridTemplateRows: `repeat(${rows}, auto)`,
        gap,
        columnGap,
        rowGap,
      }}
    >
      {children}
    </div>
  )
}

export default Grid
